import PropTypes from 'prop-types';

import useGlobalStore from 'hooks/useGlobalStore';

export function CartSavingsBanner({ savings }) {
    const { isMisfitsTheme } = useGlobalStore();

    // CUS-4231: Update to account for all M+ variants and the correct savings amount
    return (
        <>
            <div className="mt-10 h-5 w-full rounded-tl-lg rounded-tr-lg bg-gradient-berry-blend" />
            <div className="bg-malt-off-white rounded-bl-lg rounded-br-lg p-10">
                <p className="text-body-sm text-center font-grotesk-bold">
                    With {isMisfitsTheme ? 'Misfits+' : 'Imperfect+'} you could save{' '}
                    <span className="text-cranberry">${savings.toFixed(2)}</span>
                </p>
            </div>
        </>
    );
}

CartSavingsBanner.propTypes = {
    savings: PropTypes.number.isRequired,
};
